import FormattedMessage from 'I18n/components/FormattedMessage';
import SegmentLink from './SegmentLink';
import SegmentName from './SegmentName';
import { jsx as _jsx } from "react/jsx-runtime";
const TargetingInfo = ({
  segmentIdentifier,
  targetingState,
  linkToSegment
}) => {
  if (!segmentIdentifier) {
    return targetingState ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "personalizationLib.targeting.filteredVisitors"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "personalizationLib.targeting.allVisitors"
    });
  }
  return linkToSegment ? /*#__PURE__*/_jsx(SegmentLink, {
    segmentIdentifier: segmentIdentifier
  }) : /*#__PURE__*/_jsx(SegmentName, {
    segmentIdentifier: segmentIdentifier
  });
};
export default TargetingInfo;